import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const getRolesForOrg = async (orgId: string) => {
  const res = await Api.get<AdminTypes.Role[]>(`/admin/v1/orgs/${orgId}/roles`);
  return res.data;
};
